import { z } from 'zod';

import { approvalStatusEnum } from '../incoming-items/types';

/**
 * Material Master DTO — mirrors `03-database-spec.md` §4.8.
 *
 * `material_type` and `destination_type` are open-ended controlled enums in
 * the database; on the frontend we accept any string so backend additions
 * don't break the UI before zod is regenerated.
 */

export const materialTypeOptions = [
  'board',
  'battery',
  'cable',
  'dust_loss',
  'metal',
  'mixed_resource',
  'other',
  'pallet',
  'plastic',
  'secondary_transfer',
] as const;

export const destinationTypeOptions = [
  'buyer',
  'customer',
  'internal_facility',
  'other',
  'secondary_processor',
] as const;

export const materialSchema = z.object({
  material_id: z.string(),
  japanese_name: z.string(),
  normalized_name: z.string(),
  material_type: z.string(),
  default_destination_type: z.string(),
  price_reference_flag: z.boolean(),
  hazardous_or_controlled_flag: z.boolean(),
  is_high_value: z.boolean(),
  esg_reporting_group: z.string().nullable().optional(),
  active_flag: z.boolean(),
  approval_status: approvalStatusEnum,
  approved_by: z.string().nullable().optional(),
  approved_at: z.string().nullable().optional(),
});

export type Material = z.infer<typeof materialSchema>;

export const materialCreateSchema = z.object({
  japanese_name: z.string().min(1),
  normalized_name: z.string().min(1),
  material_type: z.string().min(1),
  default_destination_type: z.string().min(1),
  price_reference_flag: z.boolean(),
  hazardous_or_controlled_flag: z.boolean(),
  is_high_value: z.boolean(),
  esg_reporting_group: z.string().optional(),
});

export type MaterialCreateInput = z.infer<typeof materialCreateSchema>;

export type MaterialUpdateInput = Partial<MaterialCreateInput> & {
  active_flag?: boolean;
};
